
// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { createLocation } from "../redux/actions/VisitLocationActions";

// const CreateVisitLocation = () => {
//   const [locationName, setLocationName] = useState("");

//   const dispatch = useDispatch();
//   const { creating, error } = useSelector((state) => state.VisitLocation);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!locationName) return;

//     dispatch(createLocation(locationName));
//     setLocationName("");
//   };

//   return (
//     <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
//       <div className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-lg">
//         <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Visit Location</h1>

//         {error && (
//           <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
//             Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="space-y-5">
//           {/* Location Name */}
//           <div>
//             <label className="block text-gray-700 font-medium mb-1">Location Name</label>
//             <input
//               type="text"
//               placeholder="Enter location name"
//               value={locationName}
//               onChange={(e) => setLocationName(e.target.value)}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
//               required
//             />
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             disabled={creating}
//             className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
//               creating
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-cyan-600 hover:bg-cyan-700"
//             }`}
//           >
//             {creating ? "Creating..." : "Create Location"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CreateVisitLocation;

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createLocation } from "../redux/actions/VisitLocationActions";
import { 
  FiPlus, 
  FiCheck, 
  FiArrowLeft, 
  FiMapPin, 
  FiAlertCircle,
  FiNavigation
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const CreateVisitLocation = () => {
  const [formData, setFormData] = useState({
    location_name: ""
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { creating, error, success } = useSelector((state) => state.VisitLocation);

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };


const handleSubmit = (e) => {
  e.preventDefault();

  if (!formData.location_name.trim()) return;

  dispatch(createLocation(formData.location_name.trim()));
};

  // Reset form when creation is successful
  React.useEffect(() => {
    if (success && !creating) {
      setFormData({
        location_name: ""
      });
    }
  }, [success, creating]);

  const isFormValid = formData.location_name.trim() !== "";

  if (creating) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400 text-lg">Creating Location...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate("/dashboard/visit-Location")}
            className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            <FiArrowLeft className="text-lg" />
            Back to Locations
          </button>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
          {/* Form Header */}
          <div className="bg-gradient-to-r from-blue-500 to-cyan-500 px-6 py-8">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-white/20 rounded-xl">
                <FiMapPin className="text-2xl text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-white mb-2">
                  Create Visit Location
                </h1>
                <p className="text-blue-100">
                  Add a new location for task assignments and visits
                </p>
              </div>
            </div>
          </div>

          {/* Form Content */}
          <div className="p-6">
            {/* Success Message */}
            {success && (
              <div className="mb-6 p-4 bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 rounded-xl">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <FiCheck className="text-white text-sm" />
                  </div>
                  <div>
                    <p className="text-green-800 dark:text-green-300 font-medium">
                      Location created successfully!
                    </p>
                    <p className="text-green-600 dark:text-green-400 text-sm">
                      The new visit location is now available for use.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Error Message */}
            {error && (
              <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-xl">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
                    <FiAlertCircle className="text-white text-sm" />
                  </div>
                  <div>
                    <p className="text-red-800 dark:text-red-300 font-medium">
                      {typeof error === "string" ? error : error?.message || "Something went wrong"}
                    </p>
                    <p className="text-red-600 dark:text-red-400 text-sm mt-1">
                      Please check your input and try again.
                    </p>
                  </div>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 gap-6">
                {/* Location Name */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    <div className="flex items-center gap-2">
                      <FiNavigation className="text-sm" />
                      Location Name <span className="text-red-500">*</span>
                    </div>
                  </label>
                  <input
                    type="text"
                    value={formData.location_name}
                    onChange={(e) => handleChange("location_name", e.target.value)}
                    placeholder="Enter location name (e.g., Client Office, Site Location, Meeting Venue, etc.)"
                    className="w-full bg-white dark:bg-gray-700 border-0 rounded-xl py-3 px-4 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 transition placeholder-gray-500 dark:placeholder-gray-400"
                    required
                    disabled={creating}
                  />
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    This will be the name used when assigning tasks to this location
                  </p>
                </div>
              </div>

              {/* Common Locations Preview */}
              <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-4">
                <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-3 flex items-center gap-2">
                  <FiMapPin className="text-sm" />
                  Common Location Types
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                  {[
                    'Client Office', 'Site Visit', 'Meeting Room', 
                    'Project Site', 'Head Office', 'Branch Office',
                    'Construction Site', 'Warehouse', 'Retail Store',
                    'Hospital', 'School', 'Government Office'
                  ].map((location) => (
                    <button
                      key={location}
                      type="button"
                      onClick={() => handleChange("location_name", location)}
                      className="text-xs bg-white dark:bg-gray-700 border border-blue-200 dark:border-blue-800 text-blue-700 dark:text-blue-300 py-2 px-3 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors text-center truncate"
                      title={location}
                    >
                      {location}
                    </button>
                  ))}
                </div>
                <p className="text-xs text-blue-600 dark:text-blue-400 mt-2">
                  Click on any location above to quickly fill the location name field
                </p>
              </div>

              {/* Location Categories */}
              <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-xl p-4">
                <h4 className="text-sm font-medium text-purple-900 dark:text-purple-100 mb-2 flex items-center gap-2">
                  <FiNavigation className="text-sm" />
                  Location Categories
                </h4>
                <div className="space-y-2">
                  {[
                    { category: 'Office Locations', examples: 'Head Office, Branch Office, Client Office' },
                    { category: 'Site Locations', examples: 'Construction Site, Project Site, Warehouse' },
                    { category: 'Public Facilities', examples: 'Hospital, School, Government Building' },
                    { category: 'Commercial Spaces', examples: 'Retail Store, Shopping Mall, Restaurant' }
                  ].map((item, index) => (
                    <div key={index} className="text-sm">
                      <span className="font-medium text-purple-800 dark:text-purple-200">{item.category}:</span>
                      <span className="text-purple-600 dark:text-purple-400 ml-2">{item.examples}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Submit Button */}
              <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-gray-200 dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => {
                    setFormData({
                      location_name: ""
                    });
                  }}
                  disabled={creating}
                  className="flex items-center justify-center gap-2 bg-gray-500 hover:bg-gray-600 text-white py-3 px-6 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Clear Form
                </button>
                
                <button
                  type="submit"
                  disabled={creating || !isFormValid}
                  className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white py-3 px-6 rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
                >
                  {creating ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Creating Location...
                    </>
                  ) : (
                    <>
                      <FiCheck className="text-lg" />
                      Create Visit Location
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Form Tips */}
        <div className="mt-6 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-2xl p-6">
          <h3 className="text-lg font-semibold text-blue-900 dark:text-blue-100 mb-3">
            💡 Visit Location Guidelines
          </h3>
          <ul className="text-blue-800 dark:text-blue-200 text-sm space-y-2">
            <li>• Use clear and descriptive names that employees will easily recognize</li>
            <li>• Location names should be specific enough to avoid confusion</li>
            <li>• Consider including the area or landmark for better identification</li>
            <li>• Common locations include: Client offices, Project sites, Meeting venues</li>
            <li>• Locations are used when assigning tasks and tracking field visits</li>
            <li>• You can edit location details later if needed</li>
            <li>• Fields marked with * are required</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CreateVisitLocation;